import React from 'react';

// CRM icon: a handshake (partnership / relationships). Distinct from every other nav icon.
export function CrmIcon(props) {
  const { fill, style, width, height, className } = props;
  const color = fill || '#5E72E4';
  return (
    <svg
      id="crm-icon"
      width={width || '26'}
      height={height || '26'}
      viewBox="0 0 32 24"
      fill="none"
      className={className}
      style={style}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M2.3 9.7L6.9 4.8L10.2 7.1L5.5 12.1L2.3 9.7Z" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M29.7 9.7L25.1 4.8L21.8 7.1L26.5 12.1L29.7 9.7Z" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M10.2 10.6L13.6 8.1C15.1 7 17.1 7 18.6 8.1L21.8 10.4" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M9.2 13.2L13.6 16.9C14.8 17.9 16.5 17.9 17.8 17L22.7 13.2" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M11.5 11.8L14.9 9.8L20.2 12.9C21.4 13.6 21.6 15.3 20.7 16.2L18.8 17.9" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8.6 12.8L7.2 14.2" stroke={color} strokeWidth="1.8" strokeLinecap="round" />
      <path d="M10 13.9L8.6 15.4" stroke={color} strokeWidth="1.8" strokeLinecap="round" />
      <path d="M11.4 15.1L10 16.5" stroke={color} strokeWidth="1.8" strokeLinecap="round" />
      <path d="M19.9 13.8L17.7 12.5" stroke={color} strokeWidth="1.8" strokeLinecap="round" />
      <path d="M21.2 15L19 13.7" stroke={color} strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  );
}

export function StoreManagerIcon(props) {
  const { fill, style, width, height, className } = props;
  const strokeColor = fill || '#5E72E4';
  return (
    <svg
      id="store-manager-icon"
      width={width || '30'}
      height={height || '30'}
      viewBox="0 0 34 32"
      fill="none"
      className={className}
      style={style}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M4.2 26.2H28.8" stroke={strokeColor} strokeWidth="2" strokeLinecap="round" />

      <path d="M5.4 26.2V12.3L11.4 10.6V26.2" stroke={strokeColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M7.2 14.5H9.4" stroke={strokeColor} strokeWidth="1.8" strokeLinecap="round" />
      <path d="M7.2 17.9H9.4" stroke={strokeColor} strokeWidth="1.8" strokeLinecap="round" />
      <path d="M7.2 21.3H9.4" stroke={strokeColor} strokeWidth="1.8" strokeLinecap="round" />

      <path d="M12 12.1H18.2V26.2H12" stroke={strokeColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M13.7 15.6H16.5" stroke={strokeColor} strokeWidth="1.8" strokeLinecap="round" />
      <path d="M13.7 18.8H16.5" stroke={strokeColor} strokeWidth="1.8" strokeLinecap="round" />

      <path d="M18.8 13.4H25.2V26.2H18.8" stroke={strokeColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M19.6 13.4V11.3C19.6 10.7 20.1 10.2 20.7 10.2H22.6C23.2 10.2 23.7 10.7 23.7 11.3V13.4" stroke={strokeColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M20.5 15.3H22.8" stroke={strokeColor} strokeWidth="1.8" strokeLinecap="round" />
      <path d="M20.5 18.7H22.8" stroke={strokeColor} strokeWidth="1.8" strokeLinecap="round" />
      <path d="M20.7 26.2V23.9C20.7 23 21.4 22.3 22.3 22.3C23.2 22.3 23.9 23 23.9 23.9V26.2" stroke={strokeColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function UserManagerIcon(props) {
  return (
    <svg id="user-manager-icon" width="23.508" height="28.59" viewBox="0 0 17.508 14.59" fill={props.fill ? props.fill : '#5E72E4'} style={{ marginBottom: `5px` }}>
      <path d="M16.778 2H13.86a1.459 1.459 0 1 1-2.918 0H6.565a1.459 1.459 0 0 1-2.918 0H.729A.73.73 0 0 0 0 2.729v13.132a.73.73 0 0 0 .729.729h16.049a.73.73 0 0 0 .729-.729V2.729A.73.73 0 0 0 16.778 2zM5.836 7.106a1.459 1.459 0 1 1-1.459 1.46 1.459 1.459 0 0 1 1.459-1.46zm-2.918 5.837a2.188 2.188 0 0 1 2.188-2.188h1.459a2.188 2.188 0 0 1 2.188 2.188zm11.672-.729h-4.377v-1.46h4.377zm0-2.918h-4.377v-1.46h4.377z" />
    </svg>
  );
}

export function CredentialsIcon(props) {
  return (
    <svg
      id="credentials-icon"
      width="23.318"
      height="13.466"
      viewBox="0 0 23.318 13.466"
      fill={props.fill ? props.fill : '#5E72E4'}
      style={{
        stroke: `#5E72E4`,
        strokeLineCap: `round`,
        strokeLineJoin: `round`,
        strokeWidth: `2px`,
        marginBottom: `20px`
      }}
    >
      <path d="M7.746 2.34L2.428 7.659l5.318 5.319" />
      <path d="M2.428 2.34l5.318 5.319-5.318 5.318" />
    </svg>
  );
}

export function MetricsIcon(props) {
  const { fill, style, width, height, className } = props;

  return (
    <svg
      id="metrics-icon"
      width={width || '30'}
      height={height || '30'}
      viewBox="0 0 30 30"
      fill="none"
      className={className}
      style={style}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 20C7 15.5817 10.5817 12 15 12C19.4183 12 23 15.5817 23 20"
        stroke={fill || '#5E72E4'}
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <path
        d="M15 20L19.2 15.8"
        stroke={fill || '#5E72E4'}
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <circle cx="15" cy="20" r="1.6" fill={fill || '#5E72E4'} />
      <path d="M10.2 15.6L10.6 16" stroke={fill || '#5E72E4'} strokeWidth="1.8" strokeLinecap="round" />
      <path d="M15 14V14.6" stroke={fill || '#5E72E4'} strokeWidth="1.8" strokeLinecap="round" />
      <path d="M19.8 15.6L19.4 16" stroke={fill || '#5E72E4'} strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  );
}

export function ReferralPartnersIcon(props) {
  const { fill, style, width, height, className } = props;
  const strokeColor = fill || '#5E72E4';

  return (
    <svg
      id="referral-partners-icon"
      width={width || '30'}
      height={height || '30'}
      viewBox="0 0 32 32"
      fill="none"
      className={className}
      style={style}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Referring person (left) */}
      <circle cx="8" cy="10.5" r="3.1" stroke={strokeColor} strokeWidth="1.8" />
      <path d="M3 19.5C3 15.3 5.2 13.4 8 13.4C10.8 13.4 13 15.3 13 19.5" stroke={strokeColor} strokeWidth="1.8" strokeLinecap="round" />

      {/* Referred person (upper right) */}
      <circle cx="25.5" cy="6.6" r="2.3" stroke={strokeColor} strokeWidth="1.8" />
      <path d="M22 11.5C22 9.4 23.5 8.4 25.5 8.4C27.5 8.4 29 9.4 29 11.5" stroke={strokeColor} strokeWidth="1.8" strokeLinecap="round" />

      {/* Referred person (lower right) */}
      <circle cx="25.5" cy="21.4" r="2.3" stroke={strokeColor} strokeWidth="1.8" />
      <path d="M22 26.3C22 24.2 23.5 23.2 25.5 23.2C27.5 23.2 29 24.2 29 26.3" stroke={strokeColor} strokeWidth="1.8" strokeLinecap="round" />

      {/* Upper branching arrow */}
      <path d="M13.8 12.3C16.4 10.2 18.2 9 20.6 8.3" stroke={strokeColor} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M20.6 8.3L18.4 8.9" stroke={strokeColor} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M20.6 8.3L20.1 10.5" stroke={strokeColor} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />

      {/* Lower branching arrow */}
      <path d="M13.8 15.7C16.4 17.8 18.2 19 20.6 19.7" stroke={strokeColor} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M20.6 19.7L18.4 19.1" stroke={strokeColor} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M20.6 19.7L20.1 17.5" stroke={strokeColor} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
